import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  onErrorNetwork,
  resetErrorNetwork,
} from "../utils/networkStatusBus";
import { PageRoutes } from "../constants/routes";

const REDIRECT_DELAY_MS = 500;

const SKIP_REDIRECT_PATH_PREFIXES = [PageRoutes.GamePlay];

const shouldSkipRedirect = (pathname: string): boolean =>
  SKIP_REDIRECT_PATH_PREFIXES.some((p) => pathname.startsWith(`${p}/`));

export const useErrorNetworkRedirect = (): void => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | null = null;

    const handle = () => {
      if (location.pathname === PageRoutes.ErrorNetwork) return;
      if (shouldSkipRedirect(location.pathname)) {
        resetErrorNetwork();
        return;
      }

      const from = location.pathname + location.search;
      const fromState = location.state;
      timer = setTimeout(() => {
        timer = null;
        navigate(PageRoutes.ErrorNetwork, {
          replace: true,
          state: { from, fromState },
        });
      }, REDIRECT_DELAY_MS);
    };

    const unsubscribe = onErrorNetwork(handle);

    return () => {
      unsubscribe();
      if (timer) clearTimeout(timer);
    };
  }, [navigate, location.pathname, location.search, location.state]);
};
